<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>WebAwesome</h1>
					<p waBody="m" waText>Modern, accessible web component library &mdash; buttons, cards, tabs, dialogs, grids, stacks, inputs, overlays, and layout primitives, all wrapped as type-safe CRTP Java builders with dark-mode theming. WebAwesomePageConfigurator injects the CSS/JS bundles and angular-awesome loader module automatically.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:web-awesome</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.webawesome</p>
					<p waBody="s" waText>Built on: WebAwesome 1.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_129" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_130" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>COMPONENTS</div>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaCard</h4>
								<p waBody="s" waColorText="quiet" waText>Card container with outlined/filled/plain appearance variants</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components.card</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaButton</h4>
								<p waBody="s" waColorText="quiet" waText>Button with variant &#40;Brand, Success, Warning, Danger&#41; and appearance options</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components.button</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaStack</h4>
								<p waBody="s" waColorText="quiet" waText>Vertical stack layout with configurable gap</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaCluster</h4>
								<p waBody="s" waColorText="quiet" waText>Horizontal cluster layout with wrapping</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaGrid</h4>
								<p waBody="s" waColorText="quiet" waText>CSS Grid layout with configurable min column size</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaTag</h4>
								<p waBody="s" waColorText="quiet" waText>Tag/badge component with variant styling</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components.tag</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaDivider</h4>
								<p waBody="s" waColorText="quiet" waText>Horizontal divider line</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components.divider</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>WaTabs</h4>
								<p waBody="s" waColorText="quiet" waText>Tab container with tab/panel pairs</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.webawesome.components.tab</div>
							</div>
						</wa-card>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Component parity &mdash; Wa&#42; wrappers mirror WebAwesome web components &#40;buttons, inputs, overlays, layout primitives&#41;</p>
					<p waBody="s" waColorText="quiet" waText>CRTP fluent setters for Variant, Appearance, Placement, and Size attributes</p>
					<p waBody="s" waColorText="quiet" waText>Java-native hydration &mdash; WebAwesomePageConfigurator injects CSS/JS bundles and body theme classes</p>
					<p waBody="s" waColorText="quiet" waText>Dark-mode theming support with configurable theme paths</p>
					<p waBody="s" waColorText="quiet" waText>TypescriptIndexPageConfigurator exported for cross-plugin asset reuse</p>
					<p waBody="s" waColorText="quiet" waText>Layout components: WaGrid, WaStack, WaCluster for responsive layouts</p>
					<p waBody="s" waColorText="quiet" waText>Card, Tag, Button, Divider, Text components with appearance variants</p>
					<p waBody="s" waColorText="quiet" waText>Modular extensibility &mdash; single Maven module exports all component packages</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Card with Tabs</h4>
						<p waBody="s" waColorText="quiet" waText>Create a card containing tabbed content.</p>
						<markdown [data]="mdContent_131" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_132" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>WebAwesomePageConfigurator injects CSS/JS bundles and body theme classes</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">TypescriptIndexPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Exported for cross-plugin asset reuse</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						<wa-tag pill variant="success">provides TypescriptIndexPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://webawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/WebAwesome</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>